module.exports = __webpack_public_path__ + "img/1573938587.3cf9bc0b.jpg";